import $ from 'jquery'
import _ from 'lodash'
import {Libs} from 'eyes-lib/es'
import * as Store from './modules/store'
import * as ShareFunc from './modules/sharefunc'

const uniquKey = ShareFunc.getUniquKey()

$(function(){

    /** @type {ShohinItem} */
    const shohinJson = _.get(window,"shohinJson");
    
    /** 初期処理 */
    
    /** @type {import("./modules/store").CartData} 旅客情報 */
    var cart = Store.App.session.getItem(uniquKey);


    /** お客さん予約状況の初期化 */
    const userchoose =  Store.UserChoose.new()

    const paths = location.href.split("reserve/");
    const data = paths[1].split("/");

    userchoose.tour_code = data[0]
    userchoose.branch_code = data[1]
    userchoose.from_date = data[2]
    userchoose.display_url = this.location.href
    userchoose.debug_flag = parseInt($("#DSP").val().toString())


    //初期状態の復元
    if(cart != null){
        cart.userchoose = userchoose

        /** 商品情報の入れ込み */
        const shohin = Store.Shohin.new()

        shohin.shohin_code = shohinJson.tourCode
        shohin.shohin_name = shohinJson.name
        shohin.shohin_subtitle = shohinJson.subtitle
        shohin.from_date = shohinJson.fromDate
        shohin.to_date = shohinJson.toDate
        cart.shohin = shohin;


        const roomList = cart.room

        roomList.forEach(function(room){
            //部屋数
            const roomElm = $(`#roompax${room.roomclass_code}`)
            roomElm.val(room.roomclass_count)

            //旅客人数
            room.passenger.forEach(function(passenger){
                const passengerElm = $(`#roompaxpass${room.roomclass_code}_${passenger.passenger_code}`)
                passengerElm.val(passenger.passenger_count)
            })
        })

		$("#extend").val(cart.extend_count)

    }else{

        /** @type {import("./modules/store").CartData} 旅客情報 */
        cart = Store.CartData.new()
        
        cart.userchoose = userchoose

        /** 判別コードの入れ込み */
        cart.uniqueId = Libs.uniqId()

        /** 商品情報の入れ込み */
        const shohin = Store.Shohin.new()

        shohin.shohin_code = shohinJson.tourCode
        shohin.shohin_name = shohinJson.name
        shohin.shohin_subtitle = shohinJson.subtitle
        shohin.from_date = shohinJson.fromDate
        shohin.to_date = shohinJson.toDate
        cart.shohin = shohin;

        /** 開発のみ */
        const person = Store.Person.new()
        const dokoList = []
        dokoList.push(Store.PersonDoko.new())

        person.person_doko_list = dokoList;

        cart.person = person

    }
    Store.App.session.setItem(uniquKey,cart)


    /** 次へを押した時の処理 */
    $("body").on("click",".NextBtn", evt => {

        
        /** データ保存 */
        const cart = saveRoomData2Strage()

        if(checkInput(cart)){
            $("#cartdata").val(JSON.stringify(cart));
            $("#f").submit()
        }

        return false;

    })

    
    /** 入力情報のリセット */
    $("body").on("click",".ResetBtn",() => {
        $("select").each(function(){
            $(this).prop("selectedIndex",0)
        })

        /** データ保存 */
        saveRoomData2Strage()
        dispTotalPax()

    })

    dispTotalPax()

    /** ツアー情報の表示 */
    ShareFunc.dispTourTitle(cart.shohin)

    /** 合計人数の計算 */
    $("body").on("change",".totalPaxCalc",() => {dispTotalPax()})



})

/** 画面情報をストレージに保存 */
function saveRoomData2Strage(){

    /** @type {import("./modules/store").RoomPax[]} 旅客情報 */
    const roomPaxList = []

    $(".roompaxpassenger").each(function(){
        /** 部屋情報保存 */
        const roomSelect = $(this).find(".roompax")

        if(roomSelect.val() > 0 ){

            /** @type {import("./modules/store").RoomPax} 旅客情報 */
            const room = Store.RoomPax.new()

            room.roomclass_code = roomSelect.data("roompaxCode")
            room.roomclass_name = roomSelect.data("roompaxName")
            room.roomclass_count = parseInt(roomSelect.val().toString())

            /** 旅客の保存 */
            /** @type {import("./modules/store").Passenger[]} 旅客情報 */
            const passengerList = [];

            $($(this).find(".passenger")).each(function(){

                const passSelect = $(this)

                if(passSelect.val() > 0){
                    const pass = Store.Passenger.new()

                    pass.passenger_code = passSelect.data("passengerCode")
                    pass.passenger_name = passSelect.data("passengerName")
                    pass.passenger_paxtype = passSelect.data("passengerPaxtype")
                    pass.passenger_soineflag = passSelect.data("passengerSoineflag")
                    pass.passenger_count = parseInt(passSelect.val().toString())

                    if(pass.passenger_count > 0)
                        passengerList.push(pass)

                }
            })

            if(passengerList.length > 0){
                room.passenger = passengerList
                roomPaxList.push(room)
            }
        }

    })

    /** 部屋タイプ関係ない旅客情報 */
    /** @type {import("./modules/store").Passenger[]} 旅客情報 */
    const cectorPassList = _(roomPaxList)
                        .flatMap(room => {
                            return room.passenger
                        }).groupBy("passenger_code")
                        .map((passList,code) =>{
                            const pass = passList[0]

                            const cectorPass = Store.Passenger.new()

                            cectorPass.passenger_code = pass.passenger_code
                            cectorPass.passenger_name = pass.passenger_name
                            cectorPass.passenger_paxtype = pass.passenger_paxtype

                            cectorPass.passenger_count = _(passList).map(pass => {return pass.passenger_count}).sum()                            

                            return cectorPass
                        }).value()




    /** ストレージからデータを引き出し再び保存 */
    /** @type {import("./modules/store").CartData} 旅客情報 */
    const cartData = Store.App.session.getItem(uniquKey)

    cartData.room = roomPaxList        
    cartData.passenger = cectorPassList

    /** CartDataに延長日数を保存 */
    cartData.extend_count = Number($("#extend").val());

    
    Store.App.session.setItem(uniquKey,cartData)

    return cartData

}

/** 合計人数の表示 */
function dispTotalPax(){

    /** データ保存 */
    /** @type {import("./modules/store").CartData} 旅客情報 */
    const cartData = saveRoomData2Strage()

    const totalPax = _(cartData.room)
                    .flatMap(room =>{
                        return room.passenger
                    }).map(passenger => {
                        return passenger.passenger_count
                    }).sum();

    
    $("#totalPax").text(totalPax)
}


/** 入力のチェック */
const checkInput = cart => {

    const isNotTravel = $(`#isNotTravel`).val();


    const errList = 
        _(cart.room).map(r => {

            /** @type {import("./modules/store").RoomPax} 部屋情報*/
            const room = r;

            const roomElm = $(`#roompax${room.roomclass_code}`)
            const minPax = parseInt(roomElm.data("paxFrom"))
            const maxPax = parseInt(roomElm.data("paxTo"))

            /** 大人と子供のみの合計数 */
            //const qty = _(room.passenger).filter(p => {return p.passenger_paxtype != 2}).map(p => {return p.passenger_count}).sum();

			/** 大人と子供(添い寝は除く)のみの合計数 */
			const qty = _(room.passenger)
				.filter(p => {return ( (p.passenger_paxtype != 2) && (!(p.passenger_paxtype==1 && p.passenger_soineflag=='1')) )})
				.map(p => {return p.passenger_count})
				.sum()


            var errorStr = "";

            if(qty < minPax * room.roomclass_count || qty > maxPax * room.roomclass_count){
                errorStr = `${room.roomclass_name}の人数は1部屋 ${minPax}人〜${maxPax} 以内で設定してください`
            }

            return errorStr;

        }).filter(e => {return e != ""}).value();


    if(cart.room.length == 0){
		if(isNotTravel==`1`){
			errList.push( "数量を選択してください" )
		}else{
			errList.push( "部屋を選択してください" )
		}
    }

    if(errList.length==0){
        $(".error").html("");
        return true;

    }else{
        var errStr = "";
        errList.forEach(val => {
            errStr += `<li><span class="Info">${val}</span></li>`
        });
        $(".error").html(errStr);
        var top_pos = $(".error").offset().top;
        $("html, body").animate({ scrollTop: top_pos }, 'slow','swing');
        return false;
    }


}